export const DashboardFeatures = {
  CR: 'CR',
  DDT: 'DDT'
}
